import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "external_link",
  "use": "external_link-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 14\" id=\"external_link\">\n<g>\n\t<polygon fill-rule=\"evenodd\" clip-rule=\"evenodd\" points=\"13.5,0 8,0 8,1 12.3,1 5.7,7.6 6.4,8.3 13,1.7 13,6 14,6 14,0.5 14,0 \t\n\t\t\" />\n\t<polygon fill-rule=\"evenodd\" clip-rule=\"evenodd\" points=\"13,13 1,13 1,1 5,1 5,0 1.5,0 0,0 0,0.5 0,12.5 0,14 1.5,14 13.5,14 \n\t\t14,14 14,12.5 14,9 13,9 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol